<template>
  <vue-good-table :columns="columns" :rows="users" />
</template>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    VueGoodTable
  },
  props: {
    users: { type: Array, required: true }
  },
  data () {
    return {
      columns: [
        {
          label: 'ชื่อ - สกุล',
          field: 'thFullName'
        },
        {
          label: 'Username',
          field: 'username'
        },
        {
          label: 'อีเมล',
          field: 'email'
        }
      ]
    }
  }
}
</script>
